import React from 'react';
import { Box, Typography } from '@mui/material';

interface QuoteBoxProps {
    text: string;
    maxWidth: string;
    hasOverlay?: boolean;
    author?: string;
}

const QuoteBox: React.FC<QuoteBoxProps> = ({ text, maxWidth, author = "", hasOverlay = false }) => {
    return (
        <Box
            className={hasOverlay ? "overlay-background" : ""}
            sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: { xs: '1rem', sm: '1.5rem', md: '2rem' },
                height: { xs: 'auto', sm: '400px', md: '500px' },
                minHeight: { xs: '300px' }
            }}
        >
            <Typography
                variant="h2"
                sx={{
                    color: '#1F1B9E',
                    fontSize: { xs: '1.75rem', sm: '2.5rem', md: '3rem', lg: '3.5rem' },
                    textAlign: 'center',
                    maxWidth: { xs: '95%', sm: '90%', md: maxWidth },
                    margin: '0 auto',
                    fontWeight: 'normal',
                    lineHeight: { xs: 1.3, sm: 1.4, md: 1.5 },
                    padding: { xs: '1rem', sm: '1.5rem', md: '2rem' }
                }}
            >
                {text}
                {author && (
                    <>
                        <Box component="br" sx={{ display: { xs: 'none', sm: 'block' } }} />
                        <Typography
                            component="span"
                            sx={{
                                display: { xs: 'block', sm: 'inline' },
                                mt: { xs: 2, sm: 0 },
                                fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem', lg: '3rem' }
                            }}
                        >
                            {author ? `- ${author}` : ''}
                        </Typography>
                    </>
                )}
            </Typography>
        </Box>
    );
};

export default QuoteBox;